import { render } from "./SubFamilyLearnMoreLink.vue?vue&type=template&id=1f4e9ca8"
import script from "./SubFamilyLearnMoreLink.vue?vue&type=script&lang=js"
export * from "./SubFamilyLearnMoreLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__